import {useRef, useState} from "react";
import classes from "../forms/forms.module.css";

const InputFile = ({label, accept, onChange}) => {
    const inputRef = useRef(null);
    const [fileName, setFileName] = useState("");

    const handleChange = (e) => {
        const f = e.target.files && e.target.files[0];
        setFileName(f ? f.name : "");
        if (onChange) onChange(e);
    };

    return (
        <div>
            <label className={classes.label}>{label}</label>
            <div className={classes.fileRow}>
                <button
                    type="button"
                    className={classes.fileBtn}
                    onClick={() => inputRef.current && inputRef.current.click()}
                >
                    Выберите файл
                </button>
                <span className={classes.fileName} title={fileName}>
                    {fileName || "Файл не выбран"}
                </span>
                <input
                    ref={inputRef}
                    type="file"
                    accept={accept}
                    onChange={handleChange}
                    style={{display: "none"}}
                />
            </div>
        </div>
    )
};

export default InputFile;
